import { Component, inject, ViewChild } from '@angular/core';
import { ThemeToggleComponent } from '../theme-toggle/theme-toggle.component';
import { ThemeService } from '../../services/theme/theme.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { SidebarService } from '../../services/sidebar/sidebar.service';
import { Observable } from 'rxjs';
import { Router, RouterLink } from '@angular/router';
import { GlassModalComponent } from '../glass-modal/glass-modal.component';
import { UserLoginComponent } from '../../../features/user/user-login/user-login.component';
import { UserRegisterComponent } from '../../../features/user/user-register/user-register.component';
import { AuthApiService } from '../../services/auth/auth-api.service';
import { ForgotPasswordComponent } from '../../../features/user/forgot-password/forgot-password.component';
import { ToastrService } from 'ngx-toastr';
import { SvgLogoutComponent } from '../sidebar/svg/svg-logout.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    ThemeToggleComponent,
    NgClass,
    AsyncPipe,
    RouterLink,
    GlassModalComponent,
    UserLoginComponent,
    UserRegisterComponent,
    ForgotPasswordComponent,
    SvgLogoutComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private _themeService = inject(ThemeService);
  private _sidebarService = inject(SidebarService);
  private _authService: AuthApiService = inject(AuthApiService);
  private _router = inject(Router);
  private _toast = inject(ToastrService);

  @ViewChild('loginModal') loginModal!: GlassModalComponent;
  @ViewChild('registerModal') registerModal!: GlassModalComponent;
  @ViewChild('forgotPasswordModal') forgotPasswordModal!: GlassModalComponent;

  emailForReset: string = '';

  get isDarkMode(): Observable<boolean> {
    return this._themeService.isDarkMode();
  }

  get isLoggedIn(): boolean {
    return this._authService.isLoggedIn();
  }

  switchSidebarDisplay(): void {
    this._sidebarService.switchDisplay();
  }

  closeSidebar(): void {
    this._sidebarService.closeSidebar();
  }

  openRegisterModal(): void {
    this.loginModal.closeCard();
    this.registerModal.openCard();
  }

  openForgotPasswordModal(email: string): void {
    this.emailForReset = email;
    this.loginModal.closeCard();
    this.forgotPasswordModal.openCard();
  }

  logout(): void {
    this._authService.logout$().subscribe({
      next: () => {
        this._toast.success('Vous êtes déconnecté !', 'Succès');
        this._router.navigate(['']);
      },
      error: () => {
        this._toast.error('La déconnexion a échoué.', 'Erreur');
      },
    });
  }
}
